// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import {
	Breadcrumb,
	Button,
	Card,
	Col,
	Offcanvas,
	Row,
	Tab
} from 'react-bootstrap';

// import custom components
import GridListViewButton from 'components/elements/miscellaneous/GridListViewButton';
import OffcanvasAddMaintenanceForm from '../add-new-maintenance/OffcanvasAddMaintenanceForm';
// import sub components
import MaintenanceListItems from './MaintenanceListItems';
import MaintenanceService from '../../services/MaintenanceService';

const Maintenances = () => {
	const [Maintenances, setMaintenances] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		MaintenanceService.getAllMaintenances().then((response) => {
			setMaintenances(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Maintenances{' '}
									<span className="fs-5 text-muted"> ({Maintenances.length})</span>
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Maintenances</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">

								<div>
									<Button onClick={handleShow}>Ajouter une Maintenance</Button>
									<Offcanvas
										show={show}
										onHide={handleClose}
										placement="end"
										name="end"
										style={{ width: '600px' }}
									>
										<Offcanvas.Header closeButton>
											<Offcanvas.Title as="h3">
												Enregistrer une Maintenance
											</Offcanvas.Title>
										</Offcanvas.Header>
										<Offcanvas.Body className="pt-0">
											<OffcanvasAddMaintenanceForm onClick={handleClose} />
										</Offcanvas.Body>
									</Offcanvas>
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>

					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* Maintenances in list view */}
								<MaintenanceListItems />
								{/* end of Maintenances in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Maintenances;
